import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environments/environment.model';

interface UpsertTotalNitrogenLegalNormModel {
  totalNitrogenLegalNorms: File;
  calendarYear: number;
}

interface UpsertLegalNitrogenWorkingCoefficientsModel {
  legalNitrogenWorkingCoefficients: File;
  calendarYear: number;
}

interface UpsertCropVarietySpecificNormModel {
  cropVarietySpecificNorms: File;
  calendarYear: number;
}

interface UpsertPhosphateLegalNormModel {
  phosphateLegalNorms: File;
  phosphateTransitionLegalNorms: File;
  calendarYear: number;
}

@Injectable({
  providedIn: 'root',
})
export class ImportService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/field-report/secure';

  upsertTotalNitrogenLegalNorm(data: UpsertTotalNitrogenLegalNormModel) {
    const formData = new FormData();
    formData.append('totalNitrogenLegalNorms', data.totalNitrogenLegalNorms);
    formData.append('calendarYear', String(data.calendarYear));
    return this.http.post<UpsertTotalNitrogenLegalNormModel>(`${this.baseUrl}/totalnitrogenlegalnorm/import`, formData);
  }

  upsertLegalNitrogenWorkingCoefficients(data: UpsertLegalNitrogenWorkingCoefficientsModel) {
    const formData = new FormData();
    formData.append('legalNitrogenWorkingCoefficients', data.legalNitrogenWorkingCoefficients);
    formData.append('calendarYear', String(data.calendarYear));
    return this.http.post<UpsertLegalNitrogenWorkingCoefficientsModel>(`${this.baseUrl}/legalnitrogenworkingcoefficient/import`, formData);
  }

  upsertCropVarietySpecificNorm(data: UpsertCropVarietySpecificNormModel) {
    const formData = new FormData();
    formData.append('cropVarietySpecificNorms', data.cropVarietySpecificNorms);
    formData.append('calendarYear', String(data.calendarYear));
    return this.http.post<UpsertCropVarietySpecificNormModel>(`${this.baseUrl}/cropvarietyspecificnorm/import`, formData);
  }

  upsertPhosphateLegalNorm(data: UpsertPhosphateLegalNormModel) {
    const formData = new FormData();
    formData.append('phosphateLegalNorms', data.phosphateLegalNorms);
    formData.append('phosphateTransitionLegalNorms', data.phosphateTransitionLegalNorms);
    formData.append('calendarYear', String(data.calendarYear));
    return this.http.post<UpsertPhosphateLegalNormModel>(`${this.baseUrl}/phosphatelegalnorm/import`, formData);
  }
}
